import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { serverInitialState } from './server.constant';
import { ServerAction } from './server.action';
import { ServerTranslator } from './server.translator';
import { IServerStore } from './server.interface';

export const serverReducer = reducerWithInitialState(serverInitialState)
  .case(ServerAction.loadList.started, (state): IServerStore => {
    return {
      ...state,
      listNetworkStatus: NetworkStatus.Started,
    };
  })
  .case(ServerAction.loadList.done, (state, { result }): IServerStore => {
    const data = {};

    for (const item of result) {
      data[item.serverId] = {
        ...state.data[item.serverId],
        ...item,
      };
    }
    return {
      ...state,
      data,
      listNetworkStatus: NetworkStatus.Done,
    };
  })
  .case(ServerAction.loadList.failed, (state): IServerStore => {
    return {
      ...state,
      listNetworkStatus: NetworkStatus.Failed,
    };
  })
  .case(ServerAction.load.started, (state, payload): IServerStore => {
    const { data } = state;
    const { serverId } = payload;
    const serverData = data[serverId];

    return {
      ...state,
      data: {
        ...data,
        [serverId]: {
          ...serverData,
          networkStatus: NetworkStatus.Started,
        },
      },
    };
  })
  .case(ServerAction.load.done, (state, payload): IServerStore => {
    const { data } = state;
    const { params, result } = payload;
    const serverData = data[params.serverId];

    return {
      ...state,
      data: {
        ...data,
        [params.serverId]: {
          ...serverData,
          ...result,
          networkStatus: NetworkStatus.Done,
        },
      },
    };
  })
  .case(ServerAction.load.failed, (state, payload): IServerStore => {
    const { data } = state;
    const { params: { serverId } } = payload;
    const serverData = data[serverId];

    return {
      ...state,
      data: {
        ...data,
        [serverId]: {
          ...serverData,
          networkStatus: NetworkStatus.Failed,
        },
      },
    };
  })
  .case(ServerAction.processing.started, (state): IServerStore => {
    return {
      ...state,
      listNetworkStatus: NetworkStatus.Started,
    };
  })
  .cases([ServerAction.processing.done, ServerAction.processing.failed], (state): IServerStore => {
    return {
      ...state,
      listNetworkStatus: NetworkStatus.Done,
    };
  })
  .case(ServerAction.update.done, (state, { params }): IServerStore => {
    const { data } = state;
    const serverData = data[params.serverId];

    if (!serverData) {
      return state;
    }

    return {
      ...state,
      data: {
        ...data,
        [params.serverId]: {
          ...serverData,
          throttlingInterval: params.throttlingInterval,
          riskReportingEnabled: params.riskReportingEnabled ?? serverData.riskReportingEnabled,
          // BE keeps the stored settings when the object is omitted (switch off); a sent object replaces them,
          // the derived host/port come back with the next load
          cTraderManagerSettings: params.cTraderManagerSettings
            ? ServerTranslator.toCTraderManagerSettings(params.cTraderManagerSettings)
            : serverData.cTraderManagerSettings,
        },
      },
    };
  })
  .case(ServerAction.remove.done, (state, { params }): IServerStore => {
    const newData = { ...state.data };
    delete newData[params.serverId];

    return {
      ...state,
      data: newData,
    };
  })
  .case(ServerAction.destroy, () => ({
    ...serverInitialState,
  }));
